import { render, staticRenderFns } from "./device.vue?vue&type=template&id=886e50ea&scoped=true&"
import script from "./device.vue?vue&type=script&lang=ts&"
export * from "./device.vue?vue&type=script&lang=ts&"
import style0 from "./device.vue?vue&type=style&index=0&id=886e50ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886e50ea",
  null
  
)

export default component.exports